var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"rubric-show-description","title":_vm.sectionIn.title,"ok-only":"","modal-class":"apprentice-default-modal","ok-title":_vm.$t('common.close'),"size":"md"}},[_c('p',[_vm._v("\n        "+_vm._s(_vm.sectionIn.description)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }